import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const AccountsListPage = lazy(() =>
  import('./pages/AccountsListPage').then((m) => ({ default: m.AccountsListPage })),
);
const AccountDetailPage = lazy(() =>
  import('./pages/AccountDetailPage').then((m) => ({ default: m.AccountDetailPage })),
);
const ContractsEndingSoonPage = lazy(() =>
  import('./pages/ContractsEndingSoonPage').then((m) => ({
    default: m.ContractsEndingSoonPage,
  })),
);
const CreateAccountPage = lazy(() =>
  import('../onboarding/pages/CreateAccountPage').then((m) => ({ default: m.CreateAccountPage })),
);

export const accountRoutes: RouteObject[] = [
  { path: '/accounts', element: <AccountsListPage /> },
  // CreateAccountPage lives in the onboarding module per Phase 2 spec but is
  // surfaced under /accounts/new alongside the rest of the account routes.
  // The router.tsx wiring is Phase-0 turf (out of scope here) — keeping the
  // route here too means the existing accountRoutes consumer picks it up
  // automatically if/when the router imports onboardingRoutes-aware shape.
  { path: '/accounts/new', element: <CreateAccountPage /> },
  // CT-FE-3 renewal worklist. Declared BEFORE '/accounts/:accountId' so the
  // literal segment is not swallowed by the uuid param route.
  { path: '/accounts/contracts-ending-soon', element: <ContractsEndingSoonPage /> },
  { path: '/accounts/:accountId', element: <AccountDetailPage /> },
];
